import { BaseDto } from './base.dto';

export class InvoiceProjectDto extends BaseDto {
  name: string;
}
